// src/app/Auth/components/PublicRoute.jsx

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getUserRole, isAuthenticated } from "../utils/authStorage";
import { getDashboardByRole } from "../utils/roleRedirect";

export default function PublicRoute() {
  if (isAuthenticated()) {
    return <Navigate to={getDashboardByRole(getUserRole())} replace />;
  }

  return <Outlet />;
}